import React, { useState, useEffect } from 'react'
import Calendar from 'react-calendar'
import qs from 'qs'
import MenuBar from '../layouts/MenuBar'
import loader from '../assets/img/TizetiLoaderColored.gif'
import { useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Footer from '../layouts/Footer'
import useSchedule from '../state-management/actions/auth/useSchedule'
import useCheckAvailableDates from '../state-management/actions/auth/SignUpActions'
import dayjs from 'dayjs'
import moment from 'moment'

const Schedule = () => {
  const location = useLocation()
  const [device, setDevice] = useState(null)
  // console.log(device)
  const { getAvailableDates, getNextAvailableDates, date_a, items, date_h } = useCheckAvailableDates()
  const { Schedule, isLoading, load } = useSchedule()
  // const today = new Date();

  const todays = new Date()

  const today = new Date()
  today.setDate(todays.getDate() + 1)
  const yyyy = today.getFullYear()
  let mm = today.getMonth() + 1 // Months start at 0!
  let dd = today.getDate()

  if (dd < 10) dd = '0' + dd
  if (mm < 10) mm = '0' + mm

  const formattedToday = yyyy + '-' + mm + '-' + dd

  const dateState = {
    zone_idy: location.state.detail.zone_id,
  }
  const [dates, setDate] = useState(dateState)
  const { zone_idy } = dates

  const datay = qs.stringify({
    date: formattedToday,
    zone_id: zone_idy,
  })

  const nextdata = qs.stringify({
    date: date_h,
    zone_id: zone_idy,
  })

  const Swal = require('sweetalert2')
  useEffect(() => {
    getAvailableDates(datay)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //   console.log( items);



  const [value, onChange] = useState(new Date())

  const detailsState = {
    addresses: location.state.address,
    addressy: location.state.detail.address,
    statey: location.state.detail.state,
    datey: value,
    payment_referencey: location.state.reference,
    user_idy: location.state.detail.id,
    zone_idyy: location.state.detail.zone_id,
    category_idy: location.state.category,
    sub_zone_idy: location.state.detail.sub_zone_id,
    //  available_zone_time_idy: '9',
    countryy: location.state.country,
    notes: '',
  }
  const [details, setDetails] = useState(detailsState)
  const {
    addressy,
    addresses,
    statey,
    datey,
    payment_referencey,
    user_idy,
    zone_idyy,
    category_idy,
    sub_zone_idy,
    available_zone_time_idy,
    countryy,
    // sendCustomerMail,
    notes,
  } = details

  const data = {
    address: addresses,
    address2: addressy,
    state: statey,
    date: moment(datey).format('YYYY-MM-DD'),
    payment_reference: payment_referencey,
    sendCustomerMail: true,
    user_id: user_idy,
    zone_id: zone_idyy,
    category_id: category_idy,
    sub_zone_id: sub_zone_idy,
    available_zone_time_id: available_zone_time_idy,
    country: 'ng',
    installation_notes: notes,
  }

  const onClick = (e) => {
    e.preventDefault()
    return getNextAvailableDates(nextdata)

    // return getAvailableDates(data);
  }

  const handleDetails = (e) => {
    const { value, name } = e.target
    setDetails({ ...details, [name]: value })
  }

  const onSubmit = (e) => {
    e.preventDefault()

    Schedule(data)
  }

  if (device === 0) {
    return Swal.fire({
      title: 'Payment Successful!',
      text: 'We have recieved your information. A member of our team will contact you very soon! Thank you.',
      icon: 'success',
      confirmButtonColor: '#1ac9d8',
    })
  }
  return (
    <div>
      <MenuBar />
      <div className="col-md-4 col-12 m-auto">
        <h5 className="mt-5">Choose a Preferred Installation date</h5>
        <h6>Select an availabe date from the calandar below to schedule your installation.</h6>{' '}
        {isLoading ? (
          <img src={loader} alt="Loading..." />
        ) : (
          <form className="form mt-3" onSubmit={onSubmit}>
            <div className="form-group text-center">
              <div className="mb-3 ml-3">
                <Calendar
                  // className="mr-3"
                  defaultView="month"
                  minDetail="month"
                  minDate={new Date(date_a)}
                  maxDate={new Date(date_h)}
                  onChange={onChange}
                  value={value}
                  tileDisabled={({ date }) => {
                    const dateTileInstance = dayjs(date)
                    const itemExists = items.find((item) => dayjs(item.date).isSame(dateTileInstance))

                    if (!itemExists) return false

                    const day = dateTileInstance.get('day')
                    const isWeekend = day === 0

                    const itemCount = items.find((item) => setDevice(item.installationCount))

                    const countIsMoreThan3 = itemExists.count > device
                    const noDevice = device
                    if (isWeekend || countIsMoreThan3 || !noDevice) return true
                    return false
                  }}
                />

                <div className="form-group">
                  {load ? (
                    <input
                      disabled={true}
                      className="btn signup-btn w-100 text-white"
                      value="Submitting..."
                      type="submit"
                    />
                  ) : (
                    <button type="submit" className="btn signup-btn mt-3 text-white" onClick={onClick}>
                      {' '}
                      Check Next Available Date
                    </button>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <label>Installation notes (optional)</label>
                <textarea className="form-control" name="notes" value={notes} onChange={handleDetails} placeholder="" />
              </div>
              <div className="mb-3">
                {load ? (
                  <input
                    disabled={true}
                    className=" mt-3 btn signup-btn text-white"
                    value="Submitting..."
                    type="submit"
                  />
                ) : (
                  <input className="btn signup-btn w-100 text-white" value="Submit" type="submit" />
                )}
              </div>
              {/* <input type="text" placeholder="test" className="form-control" value={reference}> </input> */}
            </div>
          </form>
        )}
      </div>
      <ToastContainer />
      <Footer />
    </div>
  )
}

export default Schedule
